import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { Account } from "@/models/Account";
import TransferDialogViewModel from "@/viewmodels/dialogs/TransferDialogViewModel";


export default /*@__PURE__*/_defineComponent({
  __name: 'TransferDialog',
  setup(__props, { expose: __expose }) {

const viewModel = new TransferDialogViewModel();

// Exponemos directamente los métodos sin usar `bind`
__expose({
  openDialog: (accounts: Account[]) => viewModel.openDialog(accounts),
  closeDialog: () => viewModel.closeDialog(),
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(viewModel).dialog.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(viewModel).dialog.value) = $event)),
    persistent: "",
    "max-width": "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, " Solicitar Transferencia ", -1)),
              _createVNode(_component_v_btn, {
                icon: "",
                flat: "",
                onClick: _unref(viewModel).closeDialog
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _unref(viewModel).selectedAccount.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(viewModel).selectedAccount.value) = $event)),
                            items: _unref(viewModel).accounts.value,
                            "item-title": "nom",
                            "item-value": "idbancocuenta",
                            label: "Seleccione una cuenta",
                            variant: "outlined",
                            compact: "dense",
                            "hide-details": "",
                            "return-object": ""
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(viewModel).amount.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(viewModel).amount.value) = $event)),
                            prefix: 
                  _unref(viewModel).getCoin(
                    _unref(viewModel).selectedAccount.value?.moneda ?? 1
                  )
                ,
                            label: "Monto",
                            variant: "outlined",
                            compact: "dense",
                            "hide-details": "",
                            type: "number"
                          }, null, 8, ["modelValue", "prefix"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_alert, {
                            type: "info",
                            variant: "tonal",
                            class: "mt-2",
                            text: "Recuerde que el límite de transferencia es de 10,000."
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "d-flex justify-end" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                loading: _unref(viewModel).loading.value,
                disabled: 
            !_unref(viewModel).selectedAccount.value ||
            !_unref(viewModel).amount.value ||
            _unref(viewModel).loading.value
          ,
                onClick: _unref(viewModel).confirm
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Confirmar ")
                ])),
                _: 1
              }, 8, ["loading", "disabled", "onClick"]),
              _createVNode(_component_v_btn, {
                color: "secondary",
                onClick: _unref(viewModel).closeDialog
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Cancelar")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})